/* Smoke One cart reliability + UX layer
 * Single-flight cart adds, smooth drawer updates, storefront inventory caps,
 * and consistent PDP add-to-cart feedback.
 */
(function () {
  'use strict';

  var drawer = document.getElementById('CustomCartDrawer');
  if (!drawer || window.__soCartOptimizerReady) return;
  window.__soCartOptimizerReady = true;

  var state = {
    refreshPromise: null,
    refreshSequence: 0,
    addBusy: false,
    quantityBusy: false,
    removeBusy: new Map(),
    openFrame: 0,
    closeTimer: 0,
    lastTrigger: null,
    lastFocused: null,
    lastRenderSignature: '',
    lastRenderAt: 0,
    productCache: new Map()
  };

  var BOGO_DRAWER_MAX_QTY = 2;
  var SHAKE_BOGO_VARIANT_IDS = ['52998528139558', '53913407455526'];

  var style = document.createElement('style');
  style.id = 'so-cart-optimizer-styles';
  style.textContent = [
    '#CustomCartDrawer .drawer-cart-items-container{transition:opacity .16s ease;}',
    '#CustomCartDrawer .drawer-cart-items-container.is-refreshing{opacity:.72;}',
    '#CustomCartDrawer .drawer-cart-item.is-updating{opacity:.55;pointer-events:none;}',
    '[data-so-cart-busy="true"]{pointer-events:none!important;opacity:1!important;}',
    '.quantity-btn.stock-plus-disabled{opacity:.35!important;cursor:not-allowed!important;background:#fff!important;color:#9ca3af!important;}',
    '.so-cart-skeleton{padding:8px 0 4px;}',
    '.so-cart-skeleton__row{display:flex;gap:14px;align-items:center;padding:12px 0;border-bottom:1px solid rgba(46,56,31,.08);}',
    '.so-cart-skeleton__img,.so-cart-skeleton__line,.so-cart-pending__tile,.so-cart-pending__pill{background:linear-gradient(90deg,#eceae4 25%,#f7f5f0 50%,#eceae4 75%);background-size:200% 100%;animation:soCartShimmer 1.15s linear infinite;}',
    '.so-cart-skeleton__img{width:80px;height:80px;border-radius:8px;flex:0 0 80px;}',
    '.so-cart-skeleton__copy{flex:1;display:grid;gap:9px;}',
    '.so-cart-skeleton__line{height:12px;border-radius:999px;width:72%;}',
    '.so-cart-skeleton__line--short{width:42%;}',
    '#CustomCartDrawer.is-pending-add .drawer-shipping-section,#CustomCartDrawer.is-pending-add .drawer-promo-banner{display:none!important;}',
    '#CustomCartDrawer.is-pending-add .drawer-cart-items-container{padding-top:10px;opacity:1!important;}',
    '#CustomCartDrawer.is-pending-add .drawer-cart-header{margin-bottom:8px;}',
    '#CustomCartDrawer.is-pending-add .custom-cart-footer{pointer-events:none;}',
    '#CustomCartDrawer.is-pending-add .drawer-checkout-btn{opacity:.42;}',
    '.so-cart-pending{display:grid;gap:26px;padding:4px 4px 14px;}',
    '.so-cart-pending__item{display:grid;grid-template-columns:86px minmax(0,1fr);gap:16px;align-items:center;padding:12px 0 20px;border-bottom:1px solid rgba(46,56,31,.08);}',
    '.so-cart-pending__image{width:86px;height:96px;border-radius:16px;}',
    '.so-cart-pending__copy{display:grid;gap:11px;}',
    '.so-cart-pending__pill{height:13px;border-radius:999px;}',
    '.so-cart-pending__pill--title{width:72%;height:15px;}',
    '.so-cart-pending__pill--meta{width:48%;}',
    '.so-cart-pending__pill--price{width:34%;}',
    '.so-cart-pending__label{margin:0 0 3px;color:#2e381f;font-size:12px;font-weight:850;letter-spacing:.08em;text-align:center;text-transform:uppercase;}',
    '.so-cart-pending__grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px;}',
    '.so-cart-pending__card{display:grid;gap:9px;}',
    '.so-cart-pending__tile{aspect-ratio:1/1;border-radius:14px;}',
    '.so-cart-pending__card .so-cart-pending__pill{height:10px;width:82%;}',
    '.so-cart-pending__card .so-cart-pending__pill:last-child{width:55%;}',
    '@keyframes soCartShimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}',
    '@media (max-width:480px){.so-cart-pending{gap:22px}.so-cart-pending__item{grid-template-columns:82px minmax(0,1fr);gap:14px}.so-cart-pending__image{width:82px;height:92px}.so-cart-pending__grid{gap:8px}}',
    '@media (prefers-reduced-motion:reduce){#CustomCartDrawer .custom-cart-content,#CustomCartDrawer .custom-cart-overlay,#CustomCartDrawer .drawer-cart-items-container{transition:none!important}.so-cart-skeleton__img,.so-cart-skeleton__line,.so-cart-pending__tile,.so-cart-pending__pill{animation:none!important}}'
  ].join('');
  document.head.appendChild(style);

  function fixPdpDeliveryCopy(root) {
    (root || document).querySelectorAll('.so-pdp-delivery-note--under-atc span').forEach(function (span) {
      if (/^Usually ships in 1[–-]2 business days with tracked delivery\.?$/i.test((span.textContent || '').trim())) {
        span.textContent = 'Ships in 1–2 business days with tracked delivery.';
      }
    });
  }
  fixPdpDeliveryCopy(document);
  document.addEventListener('shopify:section:load', function (event) {
    fixPdpDeliveryCopy(event.target || document);
  });

  function setLegacyBusy(busy) {
    try {
      if (typeof isUpdatingCart !== 'undefined') isUpdatingCart = !!busy;
    } catch (e) {}
  }

  function getContainer() {
    return document.getElementById('cartItemsContainer');
  }

  function skeletonMarkup() {
    return '<div class="so-cart-skeleton" aria-hidden="true">' +
      '<div class="so-cart-skeleton__row"><div class="so-cart-skeleton__img"></div><div class="so-cart-skeleton__copy"><div class="so-cart-skeleton__line"></div><div class="so-cart-skeleton__line so-cart-skeleton__line--short"></div></div></div>' +
      '<div class="so-cart-skeleton__row"><div class="so-cart-skeleton__img"></div><div class="so-cart-skeleton__copy"><div class="so-cart-skeleton__line"></div><div class="so-cart-skeleton__line so-cart-skeleton__line--short"></div></div></div>' +
      '</div>';
  }

  function pendingAddMarkup() {
    return '<div class="so-cart-pending" role="status" aria-live="polite" aria-label="Adding item to cart">' +
      '<div class="so-cart-pending__item">' +
        '<div class="so-cart-pending__image so-cart-pending__tile"></div>' +
        '<div class="so-cart-pending__copy">' +
          '<div class="so-cart-pending__pill so-cart-pending__pill--title"></div>' +
          '<div class="so-cart-pending__pill so-cart-pending__pill--meta"></div>' +
          '<div class="so-cart-pending__pill so-cart-pending__pill--price"></div>' +
        '</div>' +
      '</div>' +
      '<div class="so-cart-pending__recommendations">' +
        '<div class="so-cart-pending__grid">' +
          '<div class="so-cart-pending__card"><div class="so-cart-pending__tile"></div><div class="so-cart-pending__pill"></div><div class="so-cart-pending__pill"></div></div>' +
          '<div class="so-cart-pending__card"><div class="so-cart-pending__tile"></div><div class="so-cart-pending__pill"></div><div class="so-cart-pending__pill"></div></div>' +
          '<div class="so-cart-pending__card"><div class="so-cart-pending__tile"></div><div class="so-cart-pending__pill"></div><div class="so-cart-pending__pill"></div></div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function setPendingAdd(pending) {
    var current = document.getElementById('CustomCartDrawer');
    var container = getContainer();
    var header = current && current.querySelector('.drawer-cart-header span');
    var checkout = current && current.querySelector('#checkoutBtn');
    var footerCount = current && current.querySelector('#cartItemCountFooter');
    var footerTotal = current && current.querySelector('#cartTotalFooter');

    if (!current || !container) return;

    current.classList.toggle('is-pending-add', !!pending);
    container.classList.toggle('is-refreshing', !!pending);
    container.setAttribute('aria-busy', pending ? 'true' : 'false');

    if (pending) {
      header && (header.textContent = 'Adding to cart…');
      container.innerHTML = pendingAddMarkup();
      if (checkout) checkout.disabled = true;
      if (footerCount) footerCount.textContent = 'Adding item…';
      if (footerTotal) footerTotal.textContent = '—';
    } else {
      header && (header.textContent = 'Your Cart');
      if (checkout) checkout.disabled = false;
    }
  }

  window.setCustomCartPending = setPendingAdd;

  function setRefreshing(refreshing, allowSkeleton) {
    var container = getContainer();
    if (!container) return;
    var hasContent = !!container.querySelector('.drawer-cart-item,.drawer-empty-cart');
    container.classList.toggle('is-refreshing', !!refreshing);
    container.setAttribute('aria-busy', refreshing ? 'true' : 'false');
    if (refreshing && allowSkeleton && !hasContent && !container.querySelector('.so-cart-skeleton')) {
      container.innerHTML = skeletonMarkup();
    }
  }

  function cartSignature(cart) {
    if (!cart || !Array.isArray(cart.items)) return '';
    return [cart.item_count, cart.total_price]
      .concat(cart.items.map(function (item) { return item.key + ':' + item.quantity + ':' + item.final_line_price; }))
      .join('|');
  }

  function prepareImages() {
    var container = getContainer();
    if (!container) return;
    setPendingAdd(false);
    container.classList.remove('is-refreshing');
    container.setAttribute('aria-busy', 'false');
    container.querySelectorAll('.drawer-cart-item-image img,.drawer-upsell-card__image').forEach(function (img) {
      img.decoding = 'async';
      if (!img.getAttribute('loading')) img.loading = 'eager';
    });
  }

  var originalDisplay = typeof window.updateCartDisplay === 'function' ? window.updateCartDisplay : null;
  if (originalDisplay) {
    window.updateCartDisplay = function (cart) {
      originalDisplay(cart);
      prepareImages();
    };
  }

  function readJson(response) {
    return response.json().catch(function () { return {}; }).then(function (data) {
      if (!response.ok || (data && data.status === 422)) {
        throw new Error((data && (data.description || data.message)) || ('Cart request failed (' + response.status + ')'));
      }
      return data;
    });
  }

  function fetchCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin'
    }).then(readJson);
  }

  function enforceLocks(cart) {
    // Always enforce the 2+ oz free-gummy rule before rendering.
    // Prefer the combined cart lock because it removes the gummy gift
    // immediately when qualifying flower drops below 2 oz.
    if (typeof window.enforceCartLocks === 'function') {
      return Promise.resolve(window.enforceCartLocks(cart));
    }
    if (typeof window.enforceBundleGiftLock === 'function') {
      return Promise.resolve(window.enforceBundleGiftLock(cart)).then(function (nextCart) {
        if (typeof window.enforceFree1gLock === 'function') {
          return Promise.resolve(window.enforceFree1gLock(nextCart));
        }
        return nextCart;
      });
    }
    if (typeof window.enforceFree1gLock === 'function') {
      return Promise.resolve(window.enforceFree1gLock(cart));
    }
    return Promise.resolve(cart);
  }

  function productRoot() {
    try {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    } catch (e) {
      return '/';
    }
  }

  function currentProductHandle(form) {
    var pathMatch = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    if (pathMatch && pathMatch[1]) return decodeURIComponent(pathMatch[1]);

    if (form) {
      var root = form.closest('[data-product-handle]');
      if (root && root.dataset.productHandle) return root.dataset.productHandle;
      var productRootEl = form.closest('[data-product-root]');
      var link = productRootEl && productRootEl.querySelector('a[href*="/products/"]');
      if (link) {
        var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/i);
        if (match && match[1]) return decodeURIComponent(match[1]);
      }
    }
    return '';
  }

  function cartVariantQuantity(cart, variantId) {
    return (cart && cart.items || []).reduce(function (sum, item) {
      return String(item.variant_id) === String(variantId) ? sum + Number(item.quantity || 0) : sum;
    }, 0);
  }

  function isBogoCartItem(item) {
    var collectionIds = window.__soBogoCollectionProductIds;
    if (
      Array.isArray(collectionIds) &&
      item &&
      collectionIds.map(String).indexOf(String(item.product_id)) !== -1
    ) return true;

    var properties = item && item.properties || {};
    if (
      properties._so_bogo_offer === 'true' ||
      properties._so_bogo_offer === true ||
      properties._bogo_offer === 'true' ||
      properties._bogo_offer === true
    ) return true;

    var text = [item && item.product_title, item && item.variant_title, item && item.title]
      .filter(Boolean)
      .join(' ');
    return /\bBOGO\b/i.test(text);
  }

  function bogoMaxQtyForItem(item) {
    return item && SHAKE_BOGO_VARIANT_IDS.indexOf(String(item.variant_id)) !== -1 ? 1 : BOGO_DRAWER_MAX_QTY;
  }

  function cartItemByKey(cart, key) {
    return (cart && cart.items || []).find(function (item) { return String(item.key) === String(key); }) || null;
  }

  function handleForVariant(cart, variantId, form, hint) {
    if (hint) return hint;
    var line = (cart && cart.items || []).find(function (item) {
      return String(item.variant_id) === String(variantId) && item.handle;
    });
    return line && line.handle ? line.handle : currentProductHandle(form);
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    var cached = state.productCache.get(handle);
    if (cached && (Date.now() - cached.at) < 3000) return Promise.resolve(cached.product);

    var url = productRoot().replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '?view=inventory';
    return fetch(url, {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin'
    }).then(readJson).then(function (product) {
      state.productCache.set(handle, { at: Date.now(), product: product });
      return product;
    }).catch(function (error) {
      console.warn('Could not read product inventory for ' + handle + ':', error);
      return null;
    });
  }

  function stockInfo(cart, variantId, form, handleHint) {
    var handle = handleForVariant(cart, variantId, form, handleHint);
    if (!handle) return Promise.resolve(null);

    return fetchProduct(handle).then(function (product) {
      if (!product || !Array.isArray(product.variants)) return null;
      var variant = product.variants.find(function (candidate) {
        return String(candidate.id) === String(variantId);
      });
      if (!variant) return null;

      var managed = variant.inventory_management !== null && variant.inventory_management !== undefined && variant.inventory_management !== '';
      var inventoryQuantity = Number(variant.inventory_quantity);
      var denyOversell = String(variant.inventory_policy || '').toLowerCase() !== 'continue';
      if (!managed || !denyOversell || !Number.isFinite(inventoryQuantity)) return null;

      return {
        handle: handle,
        inventoryQuantity: Math.max(0, inventoryQuantity),
        variant: variant
      };
    });
  }

  function stockMessage(inventoryQuantity, inCart) {
    if (inventoryQuantity <= 0) return 'This item is sold out.';
    if (inventoryQuantity === 1 && inCart >= 1) return 'Only 1 is available, and it is already in your cart.';
    if (inCart > 0) return 'Only ' + inventoryQuantity + ' are available. You already have ' + inCart + ' in your cart.';
    return 'Only ' + inventoryQuantity + ' are available.';
  }

  function syncDrawerStockButtons(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    cart.items.forEach(function (item) {
      var bogo = isBogoCartItem(item);
      if (bogo || !item.handle) return;

      stockInfo(cart, item.variant_id, null, item.handle).then(function (info) {
        if (!info) return;
        var totalVariantQty = cartVariantQuantity(cart, item.variant_id);
        if (totalVariantQty < info.inventoryQuantity) return;

        var escapedKey = String(item.key);
        try { escapedKey = CSS.escape(escapedKey); } catch (e) { escapedKey = escapedKey.replace(/"/g, '\\"'); }
        var plus = document.querySelector('.drawer-cart-item[data-key="' + escapedKey + '"] .drawer-quantity-controls .quantity-btn:last-child');
        if (!plus) return;
        plus.disabled = true;
        plus.classList.add('stock-plus-disabled');
        plus.setAttribute('aria-label', 'Maximum available quantity is already in cart');
        plus.title = 'Maximum available quantity is already in cart';
      });
    });
  }

  function renderCart(cart, force) {
    if (!cart || typeof cart !== 'object') return cart;

    var signature = cartSignature(cart);
    var now = Date.now();
    var duplicate = !force && signature && signature === state.lastRenderSignature && (now - state.lastRenderAt) < 400;
    state.lastRenderSignature = signature;
    state.lastRenderAt = now;

    if (!duplicate && typeof window.updateCartDisplay === 'function') window.updateCartDisplay(cart);
    if (typeof window.updateShippingProgress === 'function') window.updateShippingProgress(cart);
    if (typeof window.updateCartCount === 'function') window.updateCartCount(cart.item_count || 0);
    if (typeof window.updateFree1gBanner === 'function') window.updateFree1gBanner(cart);

    try {
      if (typeof PROMOS_ENABLED !== 'undefined' && PROMOS_ENABLED && typeof window.checkPromoEligibility === 'function') {
        window.checkPromoEligibility(cart);
      } else if (typeof window.hidePromoBanner === 'function') {
        window.hidePromoBanner();
      }
    } catch (e) {}

    syncDrawerStockButtons(cart);
    if (typeof window.setItemsBottomPadding === 'function') requestAnimationFrame(window.setItemsBottomPadding);
    return cart;
  }

  function refreshCart(options) {
    options = options || {};
    if (state.refreshPromise && !options.force) return state.refreshPromise;

    var sequence = ++state.refreshSequence;
    var container = getContainer();
    var hadContent = !!(container && container.querySelector('.drawer-cart-item,.drawer-empty-cart'));
    setRefreshing(true, options.showSkeleton !== false);

    state.refreshPromise = fetchCart()
      .then(enforceLocks)
      .then(function (cart) {
        if (sequence === state.refreshSequence) renderCart(cart, true);
        return cart;
      })
      .catch(function (error) {
        console.warn('Smoke One cart refresh failed:', error);
        if (container && !hadContent) container.innerHTML = '<div class="drawer-error">Could not load your cart. Please try again.</div>';
        throw error;
      })
      .finally(function () {
        if (sequence === state.refreshSequence) setRefreshing(false, false);
        state.refreshPromise = null;
      });

    return state.refreshPromise;
  }

  window.loadCartItems = function () {
    return refreshCart({ showSkeleton: true });
  };

  function lockBody() {
    if (document.body.dataset.soCartScrollLocked === 'true') return;
    var y = window.scrollY || window.pageYOffset || 0;
    document.body.dataset.soCartScrollLocked = 'true';
    document.body.dataset.soCartScrollY = String(y);
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = '-' + y + 'px';
  }

  function unlockBody() {
    if (document.body.dataset.soCartScrollLocked !== 'true') return;
    var y = parseInt(document.body.dataset.soCartScrollY || '0', 10);
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.top = '';
    delete document.body.dataset.soCartScrollLocked;
    delete document.body.dataset.soCartScrollY;
    window.scrollTo(0, y);
  }

  window.openCustomCartDrawer = function (cart, options) {
    var current = document.getElementById('CustomCartDrawer');
    if (!current) return Promise.resolve(cart || null);
    options = options || {};

    if (state.closeTimer) {
      clearTimeout(state.closeTimer);
      state.closeTimer = 0;
    }
    if (state.openFrame) {
      cancelAnimationFrame(state.openFrame);
      state.openFrame = 0;
    }

    if (!current.classList.contains('open')) {
      state.lastFocused = document.activeElement && document.activeElement !== document.body ? document.activeElement : state.lastFocused;
    }

    current.classList.remove('closing');
    current.style.display = 'block';
    lockBody();

    if (cart && typeof cart === 'object') renderCart(cart, true);

    if (!current.classList.contains('open')) {
      void current.offsetWidth;
      current.classList.add('open');
      if (typeof window.setItemsBottomPadding === 'function') {
        requestAnimationFrame(window.setItemsBottomPadding);
      }
    }

    if (cart && typeof cart === 'object') return Promise.resolve(cart);
    if (options.pendingAdd) setPendingAdd(true);
    if (options.skipRefresh) return Promise.resolve(null);
    return refreshCart({ showSkeleton: true }).catch(function () { return null; });
  };

  window.closeCustomCartDrawer = function () {
    var current = document.getElementById('CustomCartDrawer');
    if (!current || current.style.display === 'none') return;

    if (state.openFrame) {
      cancelAnimationFrame(state.openFrame);
      state.openFrame = 0;
    }

    current.classList.remove('open');
    current.classList.add('closing');
    unlockBody();

    if (state.closeTimer) clearTimeout(state.closeTimer);
    state.closeTimer = window.setTimeout(function () {
      current.style.display = 'none';
      current.classList.remove('closing');
      state.closeTimer = 0;
      if (state.lastFocused && typeof state.lastFocused.focus === 'function' && document.contains(state.lastFocused)) {
        try { state.lastFocused.focus({ preventScroll: true }); } catch (e) { state.lastFocused.focus(); }
      }
    }, 320);
  };

  function setTriggerBusy(trigger, busy) {
    if (!trigger || !trigger.setAttribute) return;
    if (busy) {
      trigger.dataset.soCartWasDisabled = trigger.disabled ? 'true' : 'false';
      trigger.dataset.soCartBusy = 'true';
      trigger.setAttribute('aria-busy', 'true');
      if ('disabled' in trigger) trigger.disabled = true;
    } else {
      trigger.dataset.soCartBusy = 'false';
      trigger.removeAttribute('aria-busy');
      if ('disabled' in trigger && trigger.dataset.soCartWasDisabled !== 'true') trigger.disabled = false;
      delete trigger.dataset.soCartWasDisabled;
    }
  }

  document.addEventListener('pointerdown', function (event) {
    var trigger = event.target.closest && event.target.closest('.btn-add-to-cart,[data-add-to-cart],.add-to-cart-btn,.so-pdp-atc,button[name="add"]');
    if (trigger) state.lastTrigger = trigger;
  }, true);

  function getTrigger(form) {
    if (state.lastTrigger && document.contains(state.lastTrigger)) return state.lastTrigger;
    return form ? form.querySelector('[type="submit"],button[name="add"],.add-to-cart-btn,.so-pdp-atc') : null;
  }

  function isCartAddForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    if (form.dataset.soPdpCartOwner === 'true') return false;
    var action = (form.getAttribute('action') || '').split('?')[0];
    return /\/cart\/add\/?$/.test(action);
  }

  function isActivePdpBundle(form) {
    if (!form) return false;
    var builder = form.querySelector('[data-so-bundle-builder]');
    if (!builder) return false;
    if (builder.dataset.bundleActive === 'true') return true;

    var bundleChoice = builder.querySelector('[data-so-buy-choice="bundle"]');
    if (bundleChoice && bundleChoice.classList.contains('is-selected')) return true;

    return Array.from(builder.querySelectorAll('[data-so-bundle-item]')).some(function (item) {
      var quantity = parseInt(item.dataset.quantity || '0', 10);
      return Number.isFinite(quantity) && quantity > 0;
    });
  }

  function getRequestedQuantity(form) {
    if (!form) return 1;
    try {
      var raw = new FormData(form).get('quantity');
      var quantity = parseInt(raw || '1', 10);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    } catch (e) {
      return 1;
    }
  }

  function getLineProperties(form) {
    if (!form) return null;
    try {
      var data = new FormData(form);
      var properties = {};
      data.forEach(function (value, key) {
        var match = /^properties\[(.+)\]$/.exec(key);
        if (match && value !== '') properties[match[1]] = value;
      });
      return Object.keys(properties).length ? properties : null;
    } catch (e) {
      return null;
    }
  }

  function addPayload(payload) {
    if (typeof window.safeCartAdd === 'function') return window.safeCartAdd(payload);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(readJson);
  }

  function safeOpenCartDrawer(cart, options) {
    if (typeof window.openCustomCartDrawer !== 'function') return Promise.resolve(cart || null);
    try {
      return Promise.resolve(window.openCustomCartDrawer(cart, options)).catch(function (error) {
        console.warn('Smoke One cart drawer open skipped:', error);
        return cart || null;
      });
    } catch (error) {
      console.warn('Smoke One cart drawer open skipped:', error);
      return Promise.resolve(cart || null);
    }
  }

  window.guardedAddToCart = function (variantId, fallbackSubmit, form) {
    if (!variantId || state.addBusy) return Promise.resolve(null);

    var trigger = getTrigger(form);
    var requestedQty = getRequestedQuantity(form);
    var bogoOffer = typeof window.getBogoOfferByVariantId === 'function' ? window.getBogoOfferByVariantId(variantId) : null;
    var isFree1g = false;
    var isLimited = false;

    try { isFree1g = typeof FREE_1G_VARIANT_ID !== 'undefined' && String(variantId) === String(FREE_1G_VARIANT_ID); } catch (e) {}
    try { isLimited = typeof LIMITED_VARIANT_ID !== 'undefined' && String(variantId) === String(LIMITED_VARIANT_ID); } catch (e) {}

    var sellingPlanId = typeof window.getSellingPlanIdFromFormOrPage === 'function'
      ? window.getSellingPlanIdFromFormOrPage(form)
      : null;
    var properties = getLineProperties(form);

    function completeAdd(quantity) {
      var payload = { id: Number(variantId), quantity: Number(quantity) };
      if (sellingPlanId) payload.selling_plan = Number(sellingPlanId);
      if (properties) payload.properties = properties;

      return addPayload(payload)
        .then(fetchCart)
        .then(enforceLocks)
        .then(function (nextCart) {
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart: nextCart, source: 'so-guarded-add' }
          }));
          return safeOpenCartDrawer(nextCart).then(function () { return nextCart; });
        });
    }

    state.addBusy = true;
    setLegacyBusy(true);
    setTriggerBusy(trigger, true);

    // Perceived speed: show the drawer immediately without triggering a pre-add cart refresh.
    safeOpenCartDrawer(null, { skipRefresh: true, pendingAdd: true });

    var addPromise;

    // Normal products don't need a preflight cart/inventory request.
    // Shopify /cart/add.js is the authoritative stock check and returns 422 if unavailable.
    if (!bogoOffer && !isFree1g && !isLimited) {
      addPromise = completeAdd(requestedQty);
    } else {
      addPromise = fetchCart().then(function (cart) {
        if (isFree1g && typeof window.hasFree1g === 'function' && window.hasFree1g(cart)) {
          if (typeof window.updateFree1gBanner === 'function') window.updateFree1gBanner(cart);
          return safeOpenCartDrawer(cart).then(function () { return null; });
        }

        var qtyToAdd = isFree1g ? 1 : requestedQty;

        if (isLimited && typeof window.getCurrentVariantQuantity === 'function') {
          var existingQty = 0;
          var maxQty = 1;
          try {
            existingQty = window.getCurrentVariantQuantity(cart, LIMITED_VARIANT_ID);
            if (typeof LIMITED_MAX_QTY !== 'undefined') maxQty = Number(LIMITED_MAX_QTY || 1);
          } catch (e) {}
          var remainingLimited = Math.max(0, maxQty - existingQty);
          if (remainingLimited <= 0) {
            alert('This product is limited to 1 per order.');
            return safeOpenCartDrawer(cart).then(function () { return null; });
          }
          qtyToAdd = Math.min(qtyToAdd, remainingLimited);
        }

        if (bogoOffer) {
          if (typeof window.isAddingDifferentBogo === 'function' && window.isAddingDifferentBogo(cart, bogoOffer)) {
            var oneBogoMessage = 'Only one BOGO offer can be in the cart at a time.';
            try { if (typeof ONE_BOGO_MESSAGE !== 'undefined') oneBogoMessage = ONE_BOGO_MESSAGE; } catch (e) {}
            alert(oneBogoMessage);
            return safeOpenCartDrawer(cart).then(function () { return null; });
          }
          if (typeof window.getAddQtyForBogoOffer === 'function') {
            qtyToAdd = window.getAddQtyForBogoOffer(cart, bogoOffer);
          }
          if (!qtyToAdd) {
            alert(bogoOffer.capMessage || 'BOGO limit reached.');
            return safeOpenCartDrawer(cart).then(function () { return null; });
          }
        }

        var inventoryCheck = bogoOffer ? Promise.resolve(null) : stockInfo(cart, variantId, form, '');
        return inventoryCheck.then(function (info) {
          if (info) {
            var inCart = cartVariantQuantity(cart, variantId);
            var remaining = Math.max(0, info.inventoryQuantity - inCart);
            if (remaining <= 0 || qtyToAdd > remaining) {
              alert(stockMessage(info.inventoryQuantity, inCart));
              return safeOpenCartDrawer(cart).then(function () { return null; });
            }
          }
          return completeAdd(qtyToAdd);
        });
      });
    }

    return addPromise
      .catch(function (error) {
        console.warn('Smoke One add to cart failed:', error);
        setPendingAdd(false);
        if (error instanceof TypeError && typeof fallbackSubmit === 'function') {
          try { return fallbackSubmit(); } catch (fallbackError) { console.warn('Cart fallback submit failed:', fallbackError); }
        }
        refreshCart({ showSkeleton: false, force: true }).catch(function () {});
        alert(error && error.message ? error.message : 'Could not add to cart. Please try again.');
        return null;
      })
      .finally(function () {
        state.addBusy = false;
        setLegacyBusy(false);
        setTriggerBusy(trigger, false);
        state.lastTrigger = null;
      });
  };

  function submitCartForm(form) {
    if (!isCartAddForm(form)) return;
    var data;
    try { data = new FormData(form); } catch (e) { return; }
    var idField = form.querySelector('[name="id"]');
    var variantId = idField ? idField.value : data.get('id');
    if (!variantId) return;

    window.guardedAddToCart(
      variantId,
      function () { HTMLFormElement.prototype.submit.call(form); },
      form
    );
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.btn-add-to-cart,[data-add-to-cart],.add-to-cart-btn,.so-pdp-atc,button[name="add"]');
    if (!button) return;
    var form = button.form || button.closest('form');
    if (!isCartAddForm(form) || isActivePdpBundle(form)) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    state.lastTrigger = button;
    submitCartForm(form);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!isCartAddForm(form) || isActivePdpBundle(form)) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    submitCartForm(form);
  }, true);

  window.updateQuantity = function (key, quantity) {
    if (!key || state.quantityBusy || state.addBusy) return Promise.resolve(null);
    quantity = Math.max(0, Number(quantity) || 0);

    var escapedKey = String(key);
    try { escapedKey = CSS.escape(escapedKey); } catch (e) { escapedKey = escapedKey.replace(/"/g, '\\"'); }
    var itemElement = document.querySelector('.drawer-cart-item[data-key="' + escapedKey + '"]');

    state.quantityBusy = true;
    setLegacyBusy(true);
    if (itemElement) {
      itemElement.classList.add('is-updating');
      itemElement.querySelectorAll('button,input').forEach(function (control) { control.disabled = true; });
    }

    return fetchCart()
      .then(function (cart) {
        var line = cartItemByKey(cart, key);

        // Discount changes can regenerate Shopify line-item keys. If the key
        // rendered in the drawer is already stale, just repaint from the fresh
        // cart instead of sending an invalid /cart/change.js request.
        if (!line) {
          renderCart(cart, true);
          return { cart: cart, line: null, allowed: false, stale: true };
        }

        if (quantity <= Number(line.quantity || 0)) return { cart: cart, line: line, allowed: true };

        var bogo = isBogoCartItem(line);
        if (bogo) {
          quantity = Math.min(quantity, bogoMaxQtyForItem(line));
          return { cart: cart, line: line, allowed: true };
        }

        return stockInfo(cart, line.variant_id, null, line.handle).then(function (info) {
          if (!info) return { cart: cart, line: line, allowed: true };
          var currentVariantTotal = cartVariantQuantity(cart, line.variant_id);
          var targetVariantTotal = currentVariantTotal - Number(line.quantity || 0) + quantity;
          if (targetVariantTotal > info.inventoryQuantity) {
            alert(stockMessage(info.inventoryQuantity, currentVariantTotal));
            renderCart(cart, true);
            return { cart: cart, line: line, allowed: false };
          }
          return { cart: cart, line: line, allowed: true };
        });
      })
      .then(function (check) {
        if (!check || !check.allowed) return check && check.cart || null;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: check.line.key, quantity: quantity })
        }).then(readJson).then(enforceLocks).then(function (cart) {
          renderCart(cart, true);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, source: 'so-quantity' } }));
          return cart;
        });
      })
      .catch(function (error) {
        console.warn('Smoke One quantity update failed:', error);
        var staleLineError = /no valid id or line parameter|line item.*not found|invalid.*line/i.test(String(error && error.message || ''));
        if (staleLineError) {
          return fetchCart().then(enforceLocks).then(function (cart) {
            renderCart(cart, true);
            return cart;
          }).catch(function () { return null; });
        }

        if (itemElement) {
          itemElement.classList.remove('is-updating');
          itemElement.querySelectorAll('button,input').forEach(function (control) { control.disabled = false; });
        }
        alert(error && error.message ? error.message : 'Could not update your cart. Please try again.');
        return null;
      })
      .finally(function () {
        state.quantityBusy = false;
        setLegacyBusy(false);
      });
  };

  window.removeItem = function (key) {
    if (!key) return Promise.resolve(null);
    if (state.removeBusy.has(String(key))) return state.removeBusy.get(String(key));

    var escapedKey = String(key);
    try { escapedKey = CSS.escape(escapedKey); } catch (e) { escapedKey = escapedKey.replace(/"/g, '\\"'); }
    var itemElement = document.querySelector('.drawer-cart-item[data-key="' + escapedKey + '"]');
    var renderedVariantId = itemElement && itemElement.getAttribute('data-variant-id');
    var renderedProductId = itemElement && itemElement.getAttribute('data-product-id');

    if (itemElement) {
      itemElement.classList.add('is-updating');
      itemElement.style.pointerEvents = 'none';
      itemElement.querySelectorAll('button,input').forEach(function (control) { control.disabled = true; });
    }

    // Resolve the line from a fresh cart first. Applying/removing bundle
    // discounts can regenerate Shopify line keys between renders.
    var request = fetchCart()
      .then(function (freshCart) {
        var line = cartItemByKey(freshCart, key);

        if (!line && (renderedVariantId || renderedProductId)) {
          var matches = (freshCart.items || []).filter(function (candidate) {
            var variantMatches = !renderedVariantId || String(candidate.variant_id) === String(renderedVariantId);
            var productMatches = !renderedProductId || String(candidate.product_id) === String(renderedProductId);
            return variantMatches && productMatches;
          });
          if (matches.length === 1) line = matches[0];
        }

        // If another cart sync already removed this line, removal is complete.
        if (!line) return freshCart;

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: String(line.key), quantity: 0 })
        }).then(readJson);
      })
      .then(enforceLocks)
      .then(function (cart) {
        renderCart(cart, true);
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: cart, source: 'so-remove' }
        }));
        return cart;
      })
      .catch(function (error) {
        console.warn('Smoke One remove item failed:', error);

        // A stale key means another cart/discount sync already changed that
        // line. Refresh silently rather than showing Shopify's technical alert.
        var staleLineError = /no valid id or line parameter|line item.*not found|invalid.*line/i.test(String(error && error.message || ''));
        if (staleLineError) {
          return fetchCart().then(enforceLocks).then(function (cart) {
            renderCart(cart, true);
            return cart;
          }).catch(function () { return null; });
        }

        if (itemElement) {
          itemElement.classList.remove('is-updating');
          itemElement.style.pointerEvents = '';
          itemElement.querySelectorAll('button,input').forEach(function (control) { control.disabled = false; });
        }
        alert(error && error.message ? error.message : 'Could not remove this item. Please try again.');
        return null;
      })
      .finally(function () {
        state.removeBusy.delete(String(key));
      });

    state.removeBusy.set(String(key), request);
    return request;
  };

  function handleExternalCart(cart, shouldOpen) {
    if (cart && typeof cart === 'object') {
      renderCart(cart, false);
      if (shouldOpen) window.openCustomCartDrawer(cart);
      return;
    }
    refreshCart({ showSkeleton: shouldOpen }).then(function (nextCart) {
      if (shouldOpen) window.openCustomCartDrawer(nextCart);
    }).catch(function () {});
  }

  document.addEventListener('theme:product:add', function (event) {
    var detail = event.detail || {};
    if (detail.source === 'so-bundle-add' || detail.source === 'so-pdp-add') return;
    if (detail.cartPromise && typeof detail.cartPromise.then === 'function') {
      detail.cartPromise.then(function (cart) { handleExternalCart(cart, true); }).catch(function () { handleExternalCart(null, true); });
    } else {
      handleExternalCart(detail.cart || null, true);
    }
  });

  document.addEventListener('cart:updated', function (event) {
    var detail = event.detail || {};
    if (detail.source === 'so-guarded-add' || detail.source === 'so-quantity' || detail.source === 'so-remove') return;
    handleExternalCart(detail.cart || null, false);
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refreshCart({ showSkeleton: false }).catch(function () {});
  });
})();
